import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Container } from 'react-bootstrap';

import './MemberServiceAccount.scss';
import Header from 'src/Admin/components/common/Header/Header';
import Clock from '../../img/Clock.svg';

import useAccountUnlockVerifyLink from './hooks/useAccountUnlockVerifyLink';
import useAccountUnlockOtp from './hooks/useAccountUnlockOtp';
import { ToastContainer } from 'react-toastify';
import GenericButton from '../common/button';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import GenericSkeleton from '../coverage/coverage-details/skeleton/GenericSkeleton';

const schema = yup.object({
  otp: yup.string().required('OTP is required'),
});

const AccountUnlockOtp = () => {
  const { loading } = useAccountUnlockVerifyLink();

  const {
    data,
    configLoading,
    otpLength,
    canResend,
    generateOTPLoader,
    verifyOTPCodeLoader,
    sendOTPRequest,
    verifyOTPCode,
    isOTPBlocked,
    headingRef,
    isgenerateOtpError,
  } = useAccountUnlockOtp();

  if (loading || configLoading || generateOTPLoader) {
    return (
      <Container>
        <GenericSkeleton />
      </Container>
    );
  }
  console.log('isgenerateOtpError', isgenerateOtpError);

  if (!data || isgenerateOtpError) {
    return (
      <Container>
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Please try again."
          CustomClasses="p-0"
        />
      </Container>
    );
  }
  return (
    <Container className="otp-page">
      <div>
        <div
          role="heading"
          aria-level={1}
          className="sr-only"
          tabIndex={-1}
          ref={headingRef}
        >
          Unlock Account
        </div>
        <Header
          linkTo="/member/password-recovery-new"
          header="Unlock Account"
          className="account-recovery-header"
        />
      </div>
      <Row>
        <Col>
          <p className="otp-page-description">
            We&apos;ve sent a One Time Password (OTP) to the registered email
            ID. Please enter it below.
          </p>
        </Col>
      </Row>

      <Row className="account-recovery-otp-form">
        <Col md={8} lg={6}>
          <Formik
            validationSchema={schema}
            initialValues={{
              otp: '',
            }}
            onSubmit={async (values, { setFieldError }) => {
              await verifyOTPCode(values, setFieldError);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
            }) => (
              <Form onSubmit={handleSubmit} className="unlock-otp-form">
                <Form.Group className="mb-4" controlId="otp">
                  <Form.Label>
                    One Time Password
                    <span className="required-mark">*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    inputMode="numeric"
                    name="otp"
                    maxLength={otpLength}
                    value={values.otp}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.otp && !!errors.otp}
                  />

                  <span className="sub-title-text">
                    Enter OTP sent to you via email
                  </span>

                  <Form.Control.Feedback type="invalid">
                    {errors.otp}
                  </Form.Control.Feedback>
                </Form.Group>

                <Row className="otp-page-actions">
                  <Col md={6}>
                    <div className="opt-expire-container">
                      <img
                        className="help-card-logo"
                        src={Clock}
                        alt="success icon"
                      />

                      <span>The OTP will expire in</span>
                      <span id="otp-timer">00:00</span>
                    </div>

                    <div className="otp-footer">
                      <span>Didn&apos;t get it?</span>

                      <span
                        className={`return-login-link ${
                          !canResend ? 'disabled' : ''
                        }`}
                        onClick={() => {
                          if (canResend && !generateOTPLoader) {
                            sendOTPRequest();
                          }
                        }}
                      >
                        Resend code
                      </span>
                    </div>
                  </Col>

                  <Col md={6} className="text-right">
                    <GenericButton
                      type="submit"
                      variant="primary"
                      disabled={verifyOTPCodeLoader || isOTPBlocked}
                    >
                      Continue
                    </GenericButton>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Container>
  );
};

export default AccountUnlockOtp;
